import { useQuery } from "@tanstack/react-query";
import { dashboardApi } from "./client";

const keys = {
  all: ["dashboard"] as const,
  summary: () => [...keys.all, "summary"] as const,
};

export function useDashboardSummaryQuery() {
  return useQuery({
    queryKey: keys.summary(),
    queryFn: () => dashboardApi.summary(),
  });
}
